import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex relative" }
const _hoisted_2 = {
  key: 0,
  class: "absolute flex top-0 left-0 w-full h-full bg-brand-black z-50"
}
const _hoisted_3 = { class: "flex flex-col p-4" }
const _hoisted_4 = { class: "flex space-x-2" }
const _hoisted_5 = { class: "flex" }
const _hoisted_6 = ["src"]
const _hoisted_7 = {
  key: 1,
  class: "animate-spin h-7 w-7 text-brand-black m-auto relative z-50",
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}
const _hoisted_8 = {
  key: 2,
  class: "m-auto",
  width: "30",
  height: "24",
  viewBox: "0 0 30 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_9 = { class: "flex flex-col p-4 space-y-4" }
const _hoisted_10 = { class: "flex flex-col space-y-2" }
const _hoisted_11 = {
  key: 0,
  class: "flex flex-col space-y-2"
}
const _hoisted_12 = ["onClick"]
const _hoisted_13 = { class: "flex space-x-4" }
const _hoisted_14 = { class: "flex text-white text-lg font-medium my-auto" }
const _hoisted_15 = {
  key: 1,
  class: "flex flex-col space-y-2"
}
const _hoisted_16 = { class: "font-medium text-white" }
const _hoisted_17 = ["onClick"]
const _hoisted_18 = { class: "flex space-x-2" }
const _hoisted_19 = { class: "flex text-white text-lg font-medium my-auto" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_buttons = _resolveComponent("ion-buttons")!
  const _component_ion_toolbar = _resolveComponent("ion-toolbar")!
  const _component_ion_header = _resolveComponent("ion-header")!
  const _component_input_field = _resolveComponent("input-field")!
  const _component_user_avatar = _resolveComponent("user-avatar")!
  const _component_user_verification_check = _resolveComponent("user-verification-check")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withCtx(() => [
      _createVNode(_component_ion_header, null, {
        default: _withCtx(() => [
          _createVNode(_component_ion_toolbar, { class: "!p-0 !m-0" }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_buttons, { class: "justify-between flex w-full" }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_button, {
                    onClick: _ctx.goBack,
                    class: "bg-brand-dark-gray rounded-md"
                  }, {
                    default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                      _createElementVNode("svg", {
                        class: "fill-current text-white w-6 h-6 p-0.5",
                        xmlns: "http://www.w3.org/2000/svg",
                        viewBox: "0 0 320 512"
                      }, [
                        _createElementVNode("path", { d: "M310.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L160 210.7 54.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L114.7 256 9.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L160 301.3 265.4 406.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L205.3 256 310.6 150.6z" })
                      ], -1)
                    ]))]),
                    _: 1
                  }, 8, ["onClick"]),
                  _createElementVNode("div", _hoisted_1, [
                    _createVNode(_component_ion_button, {
                      onClick: _ctx.createChat,
                      class: "!text-xl"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("span", {
                          class: _normalizeClass({
                                'opacity-0' : _ctx.creating,
                              'text-brand-light-gray' : !_ctx.canCreate,
                              'text-brand-lime' : _ctx.canCreate
                            })
                        }, "Create", 2)
                      ]),
                      _: 1
                    }, 8, ["onClick"]),
                    (_ctx.creating)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [...(_cache[4] || (_cache[4] = [
                          _createElementVNode("svg", {
                            class: "animate-spin m-auto h-5 w-5 text-brand-lime",
                            xmlns: "http://www.w3.org/2000/svg",
                            fill: "none",
                            viewBox: "0 0 24 24"
                          }, [
                            _createElementVNode("circle", {
                              class: "opacity-25",
                              cx: "12",
                              cy: "12",
                              r: "10",
                              stroke: "currentColor",
                              "stroke-width": "4"
                            }),
                            _createElementVNode("path", {
                              class: "opacity-75",
                              fill: "currentColor",
                              d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                            })
                          ], -1)
                        ]))]))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_ion_content, null, {
        default: _withCtx(() => [
          _cache[11] || (_cache[11] = _createElementVNode("div", { class: "flex flex-col p-4" }, [
            _createElementVNode("div", { class: "text-white font-medium text-2xl" }, "New Chat"),
            _createElementVNode("p", { class: "text-lg text-brand-light-gray" }, "Please provide your group chat with a name and image. You must invite at least 2 other people.")
          ], -1)),
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", {
                  onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.addPhoto && _ctx.addPhoto(...args))),
                  class: "flex w-14 h-14 bg-brand-lime rounded-full relative overflow-hidden"
                }, [
                  (_ctx.chatPhoto)
                    ? (_openBlock(), _createElementBlock("img", {
                        key: 0,
                        src: _ctx.chatPhoto,
                        class: "w-full h-full object-cover absolute top-0 left-0 z-10"
                      }, null, 8, _hoisted_6))
                    : _createCommentVNode("", true),
                  (_ctx.busy)
                    ? (_openBlock(), _createElementBlock("svg", _hoisted_7, [...(_cache[5] || (_cache[5] = [
                        _createElementVNode("circle", {
                          class: "opacity-25",
                          cx: "12",
                          cy: "12",
                          r: "10",
                          stroke: "currentColor",
                          "stroke-width": "4"
                        }, null, -1),
                        _createElementVNode("path", {
                          class: "opacity-75",
                          fill: "currentColor",
                          d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                        }, null, -1)
                      ]))]))
                    : _createCommentVNode("", true),
                  (!_ctx.busy)
                    ? (_openBlock(), _createElementBlock("svg", _hoisted_8, [...(_cache[6] || (_cache[6] = [
                        _createElementVNode("path", {
                          d: "M19.6094 12.9219C19.6094 14.1444 19.1237 15.3168 18.2593 16.1812C17.3949 17.0456 16.2225 17.5312 15 17.5312C13.7775 17.5312 12.6051 17.0456 11.7407 16.1812C10.8763 15.3168 10.3906 14.1444 10.3906 12.9219C10.3906 11.6994 10.8763 10.527 11.7407 9.66255C12.6051 8.79813 13.7775 8.3125 15 8.3125C16.2225 8.3125 17.3949 8.79813 18.2593 9.66255C19.1237 10.527 19.6094 11.6994 19.6094 12.9219Z",
                          fill: "#1A1B22"
                        }, null, -1),
                        _createElementVNode("path", {
                          d: "M3.9375 4.625C2.95951 4.625 2.02158 5.0135 1.33004 5.70504C0.638503 6.39658 0.25 7.33451 0.25 8.3125L0.25 19.375C0.25 20.353 0.638503 21.2909 1.33004 21.9825C2.02158 22.674 2.95951 23.0625 3.9375 23.0625H26.0625C27.0405 23.0625 27.9784 22.674 28.67 21.9825C29.3615 21.2909 29.75 20.353 29.75 19.375V8.3125C29.75 7.33451 29.3615 6.39658 28.67 5.70504C27.9784 5.0135 27.0405 4.625 26.0625 4.625H23.9016C22.9237 4.62479 21.9859 4.23615 21.2946 3.54456L19.7679 2.01794C19.0766 1.32635 18.1388 0.937709 17.1609 0.9375H12.8391C11.8612 0.937709 10.9234 1.32635 10.2321 2.01794L8.70544 3.54456C8.01406 4.23615 7.07628 4.62479 6.09837 4.625H3.9375ZM4.85938 8.3125C4.61488 8.3125 4.3804 8.21537 4.20751 8.04249C4.03463 7.8696 3.9375 7.63512 3.9375 7.39062C3.9375 7.14613 4.03463 6.91165 4.20751 6.73876C4.3804 6.56588 4.61488 6.46875 4.85938 6.46875C5.10387 6.46875 5.33835 6.56588 5.51124 6.73876C5.68412 6.91165 5.78125 7.14613 5.78125 7.39062C5.78125 7.63512 5.68412 7.8696 5.51124 8.04249C5.33835 8.21537 5.10387 8.3125 4.85938 8.3125ZM21.4531 12.9219C21.4531 14.6334 20.7732 16.2747 19.563 17.4849C18.3529 18.6951 16.7115 19.375 15 19.375C13.2885 19.375 11.6471 18.6951 10.437 17.4849C9.22676 16.2747 8.54688 14.6334 8.54688 12.9219C8.54688 11.2104 9.22676 9.56902 10.437 8.35883C11.6471 7.14863 13.2885 6.46875 15 6.46875C16.7115 6.46875 18.3529 7.14863 19.563 8.35883C20.7732 9.56902 21.4531 11.2104 21.4531 12.9219Z",
                          fill: "#1A1B22"
                        }, null, -1)
                      ]))]))
                    : _createCommentVNode("", true)
                ])
              ]),
              _createVNode(_component_input_field, {
                modelValue: _ctx.chatName,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.chatName) = $event)),
                placeholder: "Name your chat"
              }, null, 8, ["modelValue"])
            ])
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _cache[8] || (_cache[8] = _createElementVNode("div", { class: "font-medium text-xl text-white" }, "Invite people", -1)),
              _createVNode(_component_input_field, {
                placeholder: "Search by username",
                "clear-input": true,
                debounce: 300,
                modelValue: _ctx.participantSearch,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.participantSearch) = $event))
              }, {
                "icon-start": _withCtx(() => [...(_cache[7] || (_cache[7] = [
                  _createElementVNode("svg", {
                    width: "24",
                    height: "24",
                    viewBox: "0 0 24 24",
                    fill: "none",
                    xmlns: "http://www.w3.org/2000/svg"
                  }, [
                    _createElementVNode("path", {
                      d: "M21 21L16.514 16.506L21 21ZM19 10.5C19 12.7543 18.1045 14.9163 16.5104 16.5104C14.9163 18.1045 12.7543 19 10.5 19C8.24566 19 6.08365 18.1045 4.48959 16.5104C2.89553 14.9163 2 12.7543 2 10.5C2 8.24566 2.89553 6.08365 4.48959 4.48959C6.08365 2.89553 8.24566 2 10.5 2C12.7543 2 14.9163 2.89553 16.5104 4.48959C18.1045 6.08365 19 8.24566 19 10.5V10.5Z",
                      stroke: "#FFFFFF",
                      "stroke-width": "2",
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round"
                    })
                  ], -1)
                ]))]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            (_ctx.chatParticipants.length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                  _cache[10] || (_cache[10] = _createElementVNode("div", { class: "font-medium text-white" }, "Invited", -1)),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.chatParticipants, (participant, participantIndex) => {
                    return (_openBlock(), _createElementBlock("div", {
                      onClick: ($event: any) => (_ctx.chatParticipants.splice(participantIndex,1)),
                      key: participant.id,
                      class: "rounded-2xl bg-brand-dark-gray text-white flex px-4 py-3 justify-between"
                    }, [
                      _createElementVNode("div", _hoisted_13, [
                        _createVNode(_component_user_avatar, { user: participant }, null, 8, ["user"]),
                        _createElementVNode("div", _hoisted_14, _toDisplayString(participant.name), 1)
                      ]),
                      _cache[9] || (_cache[9] = _createElementVNode("div", { class: "flex my-auto" }, [
                        _createElementVNode("svg", {
                          width: "24",
                          height: "24",
                          viewBox: "0 0 24 24",
                          fill: "none",
                          xmlns: "http://www.w3.org/2000/svg"
                        }, [
                          _createElementVNode("path", {
                            d: "M12 22C10.6864 22.0013 9.38546 21.7436 8.17162 21.2415C6.95777 20.7394 5.85485 20.0029 4.926 19.074C3.99716 18.1452 3.26061 17.0423 2.75853 15.8284C2.25645 14.6146 1.99869 13.3136 2.00001 12V11.8C2.04001 9.83944 2.6553 7.93383 3.76939 6.32005C4.88348 4.70626 6.44726 3.45546 8.26636 2.72309C10.0855 1.99071 12.0797 1.80907 14.0012 2.20073C15.9227 2.59239 17.6867 3.54008 19.074 4.92603C20.4737 6.32457 21.4271 8.10693 21.8134 10.0475C22.1997 11.9881 22.0017 13.9997 21.2443 15.8277C20.487 17.6556 19.2043 19.2179 17.5588 20.3166C15.9132 21.4153 13.9787 22.0012 12 22ZM12 13.41L14.59 16L16 14.59L13.41 12L16 9.41003L14.59 8.00003L12 10.59L9.41001 8.00003L8.00001 9.41003L10.59 12L8.00001 14.59L9.41001 16L12 13.411V13.41Z",
                            fill: "#A5A7AF"
                          })
                        ])
                      ], -1))
                    ], 8, _hoisted_12))
                  }), 128))
                ]))
              : _createCommentVNode("", true),
            (_ctx.participantSearch.length && _ctx.participantSearchResults.length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                  _createElementVNode("div", _hoisted_16, "Search results (" + _toDisplayString(_ctx.participantSearchResults.length) + ")", 1),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.participantSearchResults, (participant) => {
                    return (_openBlock(), _createElementBlock("div", {
                      onClick: ($event: any) => (_ctx.chatParticipants.push(participant)),
                      key: participant.id,
                      class: "rounded-2xl bg-brand-dark-gray text-white flex px-4 py-3 space-x-4"
                    }, [
                      _createVNode(_component_user_avatar, { user: participant }, null, 8, ["user"]),
                      _createElementVNode("div", _hoisted_18, [
                        _createElementVNode("div", _hoisted_19, _toDisplayString(participant.name), 1),
                        _createVNode(_component_user_verification_check, {
                          class: "h-4",
                          user: participant
                        }, null, 8, ["user"])
                      ])
                    ], 8, _hoisted_17))
                  }), 128))
                ]))
              : _createCommentVNode("", true)
          ]),
          _cache[12] || (_cache[12] = _createElementVNode("div", { class: "safe-area-bottom" }, null, -1))
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}